import { BaseDialogBehavior } from 'App/Services/DialogService/BaseDialogBehavior';
import { Component } from 'vue-property-decorator';

export interface IFrameDialogContext {
    title: string,
    text: string
}

@Component({
    name: 'VoIFrameDialog'
})
export default class VoIFrameDialog extends BaseDialogBehavior<IFrameDialogContext> {
}
